import defaultPlaceholder from '@/assets/default-placeholder.png';

export default {
  data() {
    return {
      isFullscreen: false,
      infoContent: '',
      infoWindowPos: { lat: 0, lng: 0 },
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        maxWidth: 450,
        maxHeight: 500,
        pixelOffset: { width: 0, height: -35 },
      },
      defaultPlaceholder,
    };
  },
  methods: {
    handleMarkerHover(marker, idx) {
      if (this.isFullscreen) {
        this.infoWindowPos = { lat: marker.latitude, lng: marker.longitude };
        this.infoContent = this.getInfoWindowContent(marker);
        if (this.currentMidx === idx) {
          this.infoWinOpen = !this.infoWinOpen;
        } else {
          this.infoWinOpen = true;
          this.currentMidx = idx;
        }
      }
    },
    buildAdresse(marker) {
      const adresseParts = [
        marker.adresseCommercialeLibelle1,
        marker.adresseCommercialeLibelle2,
        marker.adresseCommercialeLibelle3,
      ].filter(Boolean);
      if (marker.codePostal || marker.ville) {
        const villeComplete = [marker.codePostal, marker.ville].filter(Boolean).join(' ');
        if (villeComplete) adresseParts.push(villeComplete);
      }

      return adresseParts.join(' ') || '';
    },
    handleFullscreenChange() {
      this.isFullscreen = !!(
        document.fullscreenElement ||
        document.webkitFullscreenElement ||
        document.mozFullScreenElement ||
        document.msFullscreenElement
      );
      if (!this.isFullscreen) this.infoWinOpen = false;
    },
    setupFullscreenListeners() {
      ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange']
        .forEach(event => document.addEventListener(event, this.handleFullscreenChange));
    },
    removeFullscreenListeners() {
      ['fullscreenchange', 'webkitfullscreenchange', 'mozfullscreenchange', 'MSFullscreenChange']
        .forEach(event => document.removeEventListener(event, this.handleFullscreenChange));
    },
  },
};



// WEBPACK FOOTER //
// ./src/services/general/fullscreenPopupMixin.js